// extracted by mini-css-extract-plugin
export default {"wrapper":"Eda-z","play":"Fda-z"};